import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Component for managing clubs and users
 */
@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html'
})
export class ManageComponent {
  public innerSidebarRouterLinks: Array<any> = [
    '/manage/club-overview-list',
    '/manage/user-list'
  ];

  constructor(public router: Router) {}

}
